function setupIntersectionObserver(elementId) {
    const targetElement = document.getElementById(elementId);
    if (!targetElement) {
      return;
    }
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          targetElement.classList.add('x-value-section--active');
        } else {
          targetElement.classList.remove('x-value-section--active');
        }
      });
    }, options);
    observer.observe(targetElement);
  }